// extracted by mini-css-extract-plugin
export default {"wrapper":"a0ieDd"};